module.exports = __webpack_public_path__ + "img/sign-21.ba224b59.jpg";